import { store } from "bukku/redux/store";

export const NumberFormatHelper = {
    getDefaultNumberFormatItem(transactionType) {
        const state = store.getState();
        const { numberFormats } = state.List;

        return numberFormats.find(
            item => item.id === NumberFormatHelper.getDefaultNumberFormatId(transactionType))
        || {};
    },

    getDefaultNumberFormat(transactionType) {
        const numberFormat = NumberFormatHelper.getDefaultNumberFormatItem(transactionType);
        return numberFormat?.format;
    },

    getDefaultNumberFormatId(transactionType) {
        const state = store.getState();
        const { settings } = state.List;

        const key = NumberFormatHelper.getKey(transactionType);
        const defaultNumberFormatId = settings[key];
        if (!defaultNumberFormatId && defaultNumberFormatId !== 0 && Object.keys(settings).length > 0)
            console.log('qq missing in settings', key);

        return defaultNumberFormatId;
    },

    getKey(transactionType) {
        return `${transactionType}_number_format_id`;
    },
};
